import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState,
  useContext,
  useEffect,
} from "react";
import { localStorageHandler } from "../utils/helpers";
import { CONSTANTS } from "../constants/Constants";

interface GlobalContextType {
  user: any;
  setUser: Dispatch<SetStateAction<any>>;
  profilesList: any;
  setProfilesList: Dispatch<SetStateAction<any>>;
  showHeader: boolean;
  setShowHeader: Dispatch<SetStateAction<boolean>>;
  isModifyDashboardModalOpen: boolean,
  setIsModifyDashboardModalOpen: Dispatch<SetStateAction<boolean>>;
  currentProfile: any,
  setCurrentProfile: Dispatch<SetStateAction<any>>
  isLoading: boolean,
  setIsLoading: Dispatch<SetStateAction<boolean>>
}


export const GlobalContext = createContext<GlobalContextType | undefined>(
  undefined
);

type UserProviderProps = {
  children: ReactNode;
};

export default function GlobalProvider({ children }: UserProviderProps) {
  const [user, setUser] = useState<any>({});
  const [showHeader, setShowHeader] = useState<boolean>(true)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [currentProfile, setCurrentProfile] = useState<any>([])

  const [profilesList, setProfilesList] = useState<any>([]);
  const [isModifyDashboardModalOpen, setIsModifyDashboardModalOpen] =
  useState<boolean>(false);

  useEffect(() => {
    const token = localStorageHandler("get", CONSTANTS.LOCAL_STORAGE_KEYS.USER_TOKEN_TXT);
    const userData = localStorageHandler("get", CONSTANTS.LOCAL_STORAGE_KEYS.USER_TXT);

    if (token && userData) {
      setUser(userData); // Set context on app load
    }
  }, []);

  return (
    <GlobalContext.Provider
      value={{ user, setUser, profilesList, setProfilesList, setShowHeader, showHeader, isModifyDashboardModalOpen, setIsModifyDashboardModalOpen, currentProfile, setCurrentProfile, setIsLoading, isLoading }}
    >
      {children}
    </GlobalContext.Provider>
  );
}

// Custom hook to use the GlobalContext
export function useGlobalContext() {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
}
